import api from 'services/api';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import { TotalPaxTransito, TotalPaxChegando, TotalPaxPartindo } from 'views/Dashboard/components';

const useStyles = makeStyles(() => ({
  root: { padding: 16 }
}));

/* Dashboard dos módulos */
const Dashboard = () => {
  const classes = useStyles();
  const [totalPaxTransito, setTotalPaxTransito] = useState(0);
  const [totalPaxChegando, setTotalPaxChegando] = useState(0);
  const [totalPaxPartindo, setTotalPaxPartindo] = useState(0);

  // carrega os totais de passageiros da empresa logada
  useEffect(() => {
    let isMounted = true;

    const loadDashBoard = async () => {
      try {
        const codempresa = parseInt(sessionStorage.getItem('codEmpresa'), 10);

        const responseTransito = await api.get(`/dashboard/front/paxdestino/${codempresa}`);

        if (isMounted) {
          setTotalPaxTransito(responseTransito.data[0].totaltransito);
        }

        const responseChegando = await api.get(`/dashboard/front/paxchegando/${codempresa}`);

        if (isMounted) {
          setTotalPaxChegando(responseChegando.data[0].totalchegando);
        }

        const responsePartindo = await api.get(`/dashboard/front/paxpartindo/${codempresa}`);

        if (isMounted) {
          setTotalPaxPartindo(responsePartindo.data[0].totalpartindo);
        }
      } catch (error) {
        console.error(error);
      }
    };

    loadDashBoard();

    // evita setState após o componente desmontar
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <TotalPaxTransito
            totalPaxTransito={totalPaxTransito}
          />
        </Grid>

        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <TotalPaxChegando
            totalPaxTransito={totalPaxChegando}
          />
        </Grid>

        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <TotalPaxPartindo
            totalPaxTransito={totalPaxPartindo}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;